import React, { useState, useEffect , useMemo , useRef} from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { MenuItem,
    Tooltip,
    TextField,
    FormControl,
    Select
} from '@material-ui/core';

import Pagination from "@material-ui/lab/Pagination";
import { useTable } from "react-table";

import { useForm } from 'react-hook-form';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";
import { monthCalendar } from '../../constants/models/monthCalendar';

import DetailPaymentService from '../../services/detail-payment.service';

import '../../styles/style.scss';
import usersService from '../../services/users.service';
import {format,lastDayOfMonth} from "date-fns"
export const DetailPaymentScreen = () => {

  const { isLoggedIn, user } = useSelector( state => state.auth);
    const an8Logged = isLoggedIn? user.noCustomer:'---';

    const dispatch = useDispatch();
    const history = useHistory();

    const currencySelected = 'es-Mx';

    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();

    const todayDate = new Date();
    const [isDownloadFile, setIsDownloadFile] = useState(false)
    const [customers, setCustomers] = useState({
      isLoading: true,
      isDisabled: true,
      data:[]
    });

    const [yearsPayment, setYearsPayment] = useState({
      isLoading: false,
      isDisabled: true,
      data:[]});
    
    const [montPayment, setMonthPayment] = useState(monthCalendar);

    const [isLoadingFilters, setIsLoadingFilters] = useState(false);
    const [detailPayment, setDetailPayment] = useState([]);
    const [detailPaymentFilters, setDetailPaymentFilters] = useState([]);
    const detailPaymentRef = useRef();

    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [pageSize, setPageSize] = useState(5);

    const pageSizes = [5, 10, 15];
  
    const [isLoadingData, setIsLoadingData] = useState(false);
  
    const [errorResponse, setErrorResponse] = useState('');
    const [isErrorResponse, setIsErrorResponse] = useState(false);
  
    detailPaymentRef.current = detailPayment;
    const {
        register,
        handleSubmit,
        getValues,
        setValue,
    } = useForm({
    });

    /**
     * Recuperar filtros
     */
    useEffect(() => {
      getCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

  /**
   * Recupera la lista de clientes
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Noviembre 2023
   */
  const getCustomers = () =>{

    setCustomers({
      isLoading: true,
      isDisabled: true,
      data:[]
    })
    usersService.getCustomerAssociatesByAN8(an8Logged).then((response)=>{
      let customersResponse = response;
        
      setCustomers({
        isLoading: false,
        isDisabled: false,
        data:customersResponse
      });
    }).catch((error)=>{
      console.log( "==========");
      setCustomers({
        isLoading: false,
        isDisabled: false,
        data:['']
      });
      
      if((sessionDifference > Number(tokenExpired) ) || error.response.status === 401){
        sesionExpired(dispatch, history);
      } else{
        actionErrorConnection(error, 'Error al recuperar clientes.');
      }
    });
  }

    const getYears = (an8) =>{
      setYearsPayment({
        isLoading: true,
        isDisabled: true,
        data: []
      });
      DetailPaymentService.getYearPayment(an8).then((response)=>{
        setYearsPayment({
          isLoading: false,
          isDisabled: false,
          data: response
        });
        setIsLoadingFilters(false);
      }).catch((error)=>{
        console.log(error);
        setYearsPayment({
          isLoading: false,
          isDisabled: false,
          data: []
        });
        setIsLoadingFilters(false);
        
        if(sessionDifference > Number(tokenExpired) || error.response.status === 401){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al recuperar años.');
        }
      });
    }

    /** 
     * Recupera el an8 seleccionado
     * @author alSanchez - ETE
     * @version 1.0.0 - Noviembre 2023
     * 
    */
  const onCustomerChange = () =>{
    const params = getValues();

    if(params.an8 && params.an8 !== ''){ 
      getYears(params.an8);
      let date = new Date();

    const year = date.getFullYear();
    const month = date.getMonth()+1<10 ? `0${date.getMonth()+1}`: date.getMonth()+1;

    onSubmit(null, year, month, false); 
    }
  }

    /** 
   * Recupera el año seleccionado y realiza busqueda de meses
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   * 
  */
    const onYearChange = () => {
      setValue("month", null);
      const params = getValues();
      let monthArrayChange = monthCalendar;
  
      if(params.year >= todayDate.getFullYear()){
        monthArrayChange = monthCalendar.filter(({numberMount})=>Number(numberMount) <= todayDate.getMonth()+1);
      }
      setMonthPayment(monthArrayChange)
    }

    /**
     * Realiza la solicitud para recuperar datos de pago por filtros
     * @param {*} data - información del formulario
     * @param {string} year - año a consultar
     * @param {string} month - mes a consultar
     * @param {boolean} pagination - valida si fue solicitado un cambio de pagina
     * @param {boolean} pageSizeChange - valida si fue realizada una solicitud de cambio de tamaño en tabla
     * @param {number} pageChange - cantidad de datos a obtener en la tabla
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021

     */
    const onSubmit = (data, year, month,pagination, pageSizeChange, pageChange) => {
      let date = new Date();
      const element = document.getElementById('collapseExample');
      const defaultMonth =  date.getMonth()+1<10 ? `0${date.getMonth()+1}`: date.getMonth()+1;
      element.classList.remove('show');
      const yearSelected = typeof(year) === "number" || typeof(year) ==="string" ? year : getValues()?.year
      const monthSelected =typeof(month) === "number" || typeof(month) ==="string"  ? month :    getValues().month ? getValues().month : defaultMonth
      console.log("getvalues", yearSelected, monthSelected )

      const dateToFormat= new Date(yearSelected , parseInt(monthSelected, 10) - 1)
      console.log(dateToFormat, "datetoformat")
      const firstDateOfMonth  = format(dateToFormat,"yyyy-MM-01")
      const lastDatefMonth = format(lastDayOfMonth(dateToFormat), "yyyy-MM-dd")
      setDetailPayment([]);
      setIsLoadingData(true);
      setIsErrorResponse(false);

      const params = getValues();
      const an8 = params.an8;
      let dateTransaction = '';

      if(!pagination) {

        if(!data) {
          dateTransaction = `${year}-${month}-`;
        } else {
          dateTransaction = getDateFilter(params); 
        }

        setDetailPaymentFilters(dateTransaction);
        setPage(1);
      }

      if(pageSizeChange){
        setPage(1);
      }

      const getTypePage= () => {
        return pageChange ? pageChange : page;
      };

      const getPageSize = () => {
        return pageSizeChange ? 1 : getTypePage()
      };

      const dataFilter = pagination ? detailPaymentFilters : dateTransaction;
      const pageSizeFilter = pageSizeChange ? pageSizeChange : pageSize;
      const pageFilter = !pagination ? 1 : getPageSize();
      const dateRange = {
        firstDateOfMonth,
        lastDatefMonth
      }
      console.log("date range", dateRange)
      getServiceDetailPayment(dataFilter, an8, pageSizeFilter, pageFilter, dateRange);
    };

    /**
     * Devulve un string con los valores del filtro de fecha
     * @param {*} params - ultimo estado de valores del formulario
     * @returns {string} - cadena compuesta por la fecha de acuerdo a datos recuperados
     * @author alSanchez - ETE
     * @version 1.0.0 - Octubre 2021
     */
    const getDateFilter = (params) =>{
      let dateString = '';

      const monthData = params.month<10 ? `${params.month}`: params.month;

      const dateComplete = (params.year && params.month) ? `${params.year}-${monthData}-` : '';
      const dateMonthOnly = (params.year && !params.month) ? `${params.year}-` : '';
      const dateYearOnly = (!params.year && params.month) ? `-${monthData}-` : '';
      const dateNone = (!params.year && !params.month) ?  '-' : '';
          
      dateString = dateComplete + dateMonthOnly + dateYearOnly + dateNone;
      
      return dateString;
    };

    /**
     * Realiza solicitud a servicio para recuperar detalle de pagos procesados
     * @param {*} dataFilter - datos de filtos
     * @param {*} pageSizeFilter - campos a obtener
     * @param {*} pageFilter - pagina a obtener
     * @author alSanchez - ETE
     * @version 1.0.0 - Octubre 2021
     */
    const getServiceDetailPayment = (dataFilter, an8, pageSizeFilter, pageFilter,dateRange) =>{
      DetailPaymentService.getAlldetailPaymentByFilters(dataFilter,an8, pageSizeFilter, pageFilter,dateRange)
      .then((response) => {
        setIsErrorResponse(false);
        setIsLoadingData(false);
        const { invoicePaid, total } = response;
        setDetailPayment(invoicePaid);
        setCount(Math.ceil(total/pageSizeFilter));
      })
      .catch((error) => {
        setIsLoadingData(false);
        console.log(error);
        if(error.response){
          setErrorResponse(error.response.data.mensaje);
          if(sessionDifference > Number(tokenExpired)){
            sesionExpired(dispatch, history);
          }
        } else{
          setErrorResponse(error);
          actionErrorConnection(error);
        }
        setIsErrorResponse(true);
      });
    }



    /**
     * Selecciona una pagina y recupera los valores de la tabla correspondientes
     * @param {*} value - pagina seleccionada
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
     const handlePageChange = (value) => {
      setPage(value.target.innerText);
      onSubmit(null,null,null,true, null, value.target.innerText);
    };
  
    /**
     * Cambia el valor de datos en la tabla y vulve a realizar la busqueda de datos
     * @param {*} event - valores de imput de cambio de tamaño de tabla
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const handlePageSizeChange = (event) => {
      setPageSize(event.target.value);
      setPage(1);
      onSubmit(null, null, null,true,event.target.value);
    };
  
    /**
     * Campos de la tabla
     */
    const columns = useMemo(
      () => [
        {
          Header: 'Cliente',
          accessor: 'an8'
        },
        {
          Header: "Número de factura",
          accessor: "invoiceNumber",
        },
        {
          Header: "Tipo de factura",
          accessor: "invoiceType",
        },
        {
          Header: "Fecha de operación",
          accessor: "dateOperation",
        },
        {
          Header: "Monto",
          accessor: "amount",
        },
        {
          Header: "Número de autorización",
          accessor: "authorizationNumber",
        }
        ,
        {
          Header: "Método de pago",
          accessor: "paymentMethod",
        }
      ],
      []
    );
  
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow
    } = useTable({
      columns,
      data: detailPayment,
    });
    const downloadFile = ()=>{
      setIsDownloadFile(true)
      const an8 = getValues().an8

    const fileName = `pagos_procesados_${an8}_${detailPaymentFilters}`;
      DetailPaymentService.downloadDetailPaymentsXls(an8, detailPayment).then((response) =>{
        const byteString = window.atob(response.split(',')[1]);
              const mimeString = response.split(',')[0].split(':')[1].split(';')[0];

              const ab = new ArrayBuffer(byteString.length);
              const ia = new Uint8Array(ab);
              for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i)
              }

              const dataBlob = new Blob([ab], { type: mimeString });

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(dataBlob, `${fileName}.xls`);
                setIsDownloadFile(false);
                return
              }

              const url = window.URL.createObjectURL(dataBlob);
              const link = document.createElement('a');
              link.href = url
              link.setAttribute('download', `${fileName}.xls`);
              document.body.appendChild(link);
              link.click();
              link.remove();

              setIsDownloadFile(false);
            },
            (error)=>{
              setIsDownloadFile(false);
              actionErrorConnection(error, 'Error al descargar archivo xls.');
            });
    }


    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                <NavTopMenu />


                <div className="container ps-3 pe-3 container-size">
                  <div className="row base-container ">
                    <div className="col-12 border-title text-title pt-2 pb-2 ps-4">
                      <span className="h4">Pagos procesados</span>
                    </div>
                  
                    <div className="col-12 pt-1 pb-3 ps-2 pe-2">
                    <div className="row ">
                      <div className="col-12 ">
                        <div className="w-100 d-flex justify-content-end">
                          {
                            isDownloadFile ?
                              <Tooltip title="Descargargando..." placement="top-start" arrow>
                                <div className="custom-icon-loading me-1">
                                  <i className="fas fa-spinner fa-spin"></i>
                                </div>
                              </Tooltip>
                              :
                              <Tooltip title="Descargar resultados" placement="top-start" arrow>
                                <div>
                                  <button
                                    className="btn custom-btn-icons"
                                    onClick={()=>downloadFile()}
                                    type="button"
                                    disabled={isLoadingData || isErrorResponse || detailPayment.length < 1}
                                  >
                                    <i className="fas fa-download"></i>
                                  </button>
                                </div>
                              </Tooltip>
                          }
                        {(customers.isLoading || yearsPayment.isLoading) && 
                          <Tooltip title="Cargando filtro..." placement="top-start" arrow>
                            <div className="custom-icon-loading me-1">
                              <i className="fas fa-spinner fa-spin"></i>
                            </div>
                          </Tooltip>
                        }
                          <Tooltip title="Filtrar" placement="top-start" arrow>
                            <button className="btn custom-btn-icons" 
                            type="button" data-bs-toggle="collapse" 
                            data-bs-target="#collapseExample" aria-expanded="false" 
                            aria-controls="collapseExample">
                              <i className="fas fa-filter"></i>
                            </button>
                          </Tooltip>
                        </div>
                        <div className="collapse show" id="collapseExample">
                          <div className="filter-continer">
                            <div className="container mt-3">
                              <form className="row">
                                <div className="col-md-5 col-lg-4 mb-3">
                                <TextField
                                    select
                                    id="an8"
                                    name="an8"
                                    label="Num. cliente*"
                                    variant="outlined"
                                    size="small" 
                                    disabled={customers.isDisabled || customers.isLoading}
                                    fullWidth
                                    defaultValue={''}
                                    {...register('an8')}
                                    onBlur={onCustomerChange}
                                    >
                                        <MenuItem value="">Seleccionar cliente</MenuItem>
                                    {customers.data.map(({noCustomer, name}) => (
                                        <MenuItem key={noCustomer} value={noCustomer}>
                                        {noCustomer} - {name}
                                        </MenuItem>
                                    ))}
                                  </TextField>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                <TextField
                                          select
                                          id="year"
                                          name="year"
                                          label="Año"
                                          variant="outlined"
                                          size="small" 
                                          fullWidth
                                          {...register('year')}
                                          defaultValue={""}
                                          disabled={yearsPayment.isDisabled || yearsPayment.isLoading}
                                          onBlur={onYearChange}
                                          >
                                              <MenuItem value="">Seleccionar año</MenuItem>
                                              {yearsPayment.data?.length === 0 && <MenuItem value="">Sin registros</MenuItem>}
                                          {yearsPayment.data?.map((option) => (
                                              <MenuItem key={option} value={option}>
                                              {option}
                                              </MenuItem>
                                          ))}
                                        </TextField>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                <TextField
                                          select
                                          id="month"
                                          name="month"
                                          label="Mes"
                                          variant="outlined"
                                          size="small" 
                                          fullWidth
                                          {...register('month')}
                                          defaultValue={""}
                                          disabled={yearsPayment.isDisabled || yearsPayment.isLoading}
                                          >
                                              <MenuItem value="">Seleccionar mes</MenuItem>
                                          {montPayment.map((option) => (
                                              <MenuItem key={option.id} value={option.numberMount}>
                                              {option.name}
                                              </MenuItem>
                                          ))}
                                        </TextField>
                                </div>
                                <div className="col-12 w-100 d-flex justify-content-end">
                                  <Tooltip title="Buscar" placement="top-start" arrow>
                                    <div>
                                      <button 
                                      className="ms-2 mb-3 btn custom-btn"
                                      disabled={isLoadingData || isLoadingFilters}
                                      onClick={handleSubmit(onSubmit)}
                                      type='submit'
                                      data-bs-toggle="collapse" 
                                      data-bs-target="#collapseExample" 
                                      aria-expanded="false" 
                                      aria-controls="collapseExample"
                                      >
                                        <i className="fas fa-search"></i>
                                      </button>
                                    </div>
                                  </Tooltip>
                                </div>
                            </form>
                            </div>
                          
                          </div>
                        </div>
                            
                            
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <table
                            className=""
                            {...getTableProps()}
                          >
                            <thead>
                              {headerGroups.map((headerGroup, i) => (
                                <tr {...headerGroup.getHeaderGroupProps()} className="border-content " key={i}>
                                  {headerGroup.headers.map((column, j) => (
                                    <th {...column.getHeaderProps()}
                                    className="border-element header-element header-text pt-3 pb-3" key={j}>
                                      {column.render("Header")}
                                    </th>
                                  ))}
                                </tr>
                              ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                              {rows.map((row) => {
                                prepareRow(row);
                                return (
                                  <React.Fragment key={row.getRowProps().key}>
                                    <tr className="element-row border-content">
                                      {row.cells.map((cell,index) => {
                                        return (
                                          <td className="border-element content-text padding-row"
                                          {...cell.getCellProps()} key={index}>

                                            {
                                              cell.column.id === 'an8' ?
                                                getValues().an8 :
                                                (cell.column.Header === 'Monto'?
                                                  `$ ${parseFloat(cell.value).toLocaleString(currencySelected,{
                                                    minimumFractionDigits: 2
                                                })}` : cell.render("Cell"))
                                              }
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  </React.Fragment>
                                );
                              })}
                            </tbody>
                          </table>
                          {(isErrorResponse) &&
                            <div className="error-message border-content pt-4 pb-4">
                              <span className="">Error: {errorResponse && errorResponse.toString()}</span>
                            </div>}
                          {(isLoadingData) &&
                            <div className="border-content pt-4 pb-4 custom-icon-loading">
                              <i className="fas fa-spinner fa-spin"></i>
                            </div>}
                            {(detailPayment.length === 0 && !isLoadingData && !isErrorResponse) &&
                            <div className="element-row-message border-content pt-4 pb-4 ">
                              <span>Los filtros seleccionanos no devolvieron coincidencias.</span>
                            </div>}
                        </div>
                        <div className="col-12">
                            <div className="row">
                              <div className="col-md-6 d-flex justify-content-end align-items-center">
                                  {<span className="pagination-message">Filas por página:</span>}
                                  <FormControl className="ps-2">
                                    <Select
                                      onChange={handlePageSizeChange} 
                                      value={pageSize}
                                      disabled={isLoadingData}
                                    >
                                      {pageSizes.map((size) => (
                                      <MenuItem key={size} value={size}>
                                        {size}
                                      </MenuItem>
                                    ))}
                                    </Select>
                                  </FormControl>
                              </div>
                              <div className="col-md-6 d-flex justify-content-end">
                                <Pagination
                                  className="my-3"
                                  count={count}
                                  page={page}
                                  siblingCount={0}
                                  shape="rounded"
                                  showFirstButton 
                                  showLastButton
                                  onChange={handlePageChange}
                                  disabled={isLoadingData|| detailPayment.length === 0  }
                                />
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
            <Footer/>
        </>
    )
}

